import React, {useEffect, useRef} from 'react'
import {dateTimeUtils} from '../../utils/dateTimeUtils'
// import {$$} from '../../helpers/localization'
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
// import {Tooltip} from 'react-bootstrap'
import classNames from 'classnames'

export function NotificationItem({item, expanded, onToggle, onMarkSeen}) {
    const isUnread = !item.seenAt;
    const ts = new Date(item.createdAt).getTime();
    const timerRef = useRef(null);

    useEffect(() => {
        if (expanded && isUnread) {
            timerRef.current = setTimeout(() => {
                onMarkSeen(item.campaignId);
            }, 5000);
        }
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [expanded, isUnread, item.campaignId, onMarkSeen]);

    return (
        <div
            className={classNames('appointment-containter pl-3', {
                'notification-unread': isUnread,
                'appointment-active': expanded
            })}
        >
            <div
                className="d-flex justify-content-between align-items-center pointer"
                onClick={() => onToggle(item.campaignId)}
            >
                <div className="flex-grow-1 mr-3">
                    <div className={isUnread ? 'font-weight-bold' : ''}>
                        {item.title}
                    </div>
                    {(item.senderName || item.senderOrganizationName) && (
                        <div className={`small ${expanded ? '' : 'medrec-grey-2'}`}>
                            {[item.senderName, item.senderOrganizationName].filter(Boolean).join(' · ')}
                        </div>
                    )}
                </div>
                <div className="text-nowrap small text-right">
                    <div>{dateTimeUtils.getLongFormattedDate(ts)}</div>
                    <div>{dateTimeUtils.getFormattedTime(ts)}</div>
                </div>
            </div>
            {expanded && (
                <>
                    <div className="notification-body mt-2 p-3">
                        <div className="font-weight-light" style={{whiteSpace: 'pre-wrap'}}>
                            {item.body}
                        </div>
                    </div>
                    {/* Manual mark-as-read button — hidden, enable if needed
                    {isUnread && (
                        <div className="mt-2">
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>{$$('mark_as_read')}</Tooltip>}
                            >
                                <span
                                    className="pointer small-link-blue"
                                    onClick={() => onMarkSeen(item.campaignId)}
                                >
                                    <i className="fa fa-envelope-open mr-2"/>
                                    {$$('mark_as_read')}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )}
                    */}
                </>
            )}
        </div>
    );
}
